import { useTranslation } from "@repo/core";
import { HiAnnotation, HiEye, HiPencil, HiTrash } from "react-icons/hi";
import type { StrategyDetailActions } from "../../../hooks/useStrategyDetailType";

const ActionButtons = ({
  actions,
  handleEditClick,
  handleRemoveClick,
  handleShowDraftClick,
  handleShowActiveClick,
  handleAddNoteClick,
  hasNote,
  modelId,
}: {
  actions: StrategyDetailActions;
  handleEditClick: () => void;
  handleRemoveClick: () => void;
  handleShowDraftClick: () => void;
  handleShowActiveClick: () => void;
  handleAddNoteClick: () => void;
  hasNote: boolean;
  modelId?: string;
}) => {
  const { tCommon, tStrategy } = useTranslation();
  const isDraft = modelId?.includes('_draft');
  return (
    <div className="hidden lg:flex items-center gap-2">
      {actions.showEdit && (
        <button
          onClick={handleEditClick}
          className="flex items-center gap-1 text-blue-600 hover:text-blue-800 transition-colors cursor-pointer mx-4"
        >
          <HiPencil size={16} />
          <span className="text-sm font-medium">{tCommon("edit")}</span>
        </button>
      )}
      {actions.showEdit && !hasNote && (
        <button
          onClick={handleAddNoteClick}
          className="flex items-center gap-1 text-blue-600 hover:text-blue-800 transition-colors cursor-pointer mx-4"
        >
          <HiAnnotation size={16} />
          <span className="text-sm font-medium">{tStrategy("note.addButton")}</span>
        </button>
      )}
      {actions.showDelete && (
        <button
          onClick={handleRemoveClick}
          className="flex items-center gap-1 text-red-600 hover:text-red-800 transition-colors cursor-pointer  mx-4"
        >
          <HiTrash size={16} />
          <span className="text-sm font-medium">{isDraft ? tCommon("deleteDraft") : tCommon("delete")}</span>
        </button>
      )}
      {actions.showDraft && (
        <button
          onClick={handleShowDraftClick}
          className="flex items-center gap-1 text-green-600 hover:text-green-800 transition-colors cursor-pointer mx-4"
        >
          <HiEye size={16} />
          <span className="text-sm font-medium">{tStrategy("showDraft")}</span>
        </button>
      )}
      {actions.showActive && (
        <button
          onClick={handleShowActiveClick}
          className="flex items-center gap-1 text-blue-600 hover:text-blue-800 transition-colors cursor-pointer"
        >
          <HiEye size={16} />
          <span className="text-sm font-medium">{tStrategy("showActive")}</span>
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
